import { useState } from 'react';

// const formatDate = (date) => {
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const day = String(date.getDate()).padStart(2, '0');
//   return `${year}-${month}-${day}`;
// };

const useHandleFiltroFecha = () => {
  // const currentDate = new Date();

  const [hasta, setHasta] = useState('');
  const [desde, setDesde] = useState('');
  const handleDesde = (e) => {
    setDesde(e.target.value);
  };
  const handleHasta = (e) => {
    setHasta(e.target.value);
  };
  const handleResetFechas = () => {
    setHasta('');
    setDesde('');
  };
  return { handleDesde, handleHasta, handleResetFechas, hasta, desde };
};

export default useHandleFiltroFecha;
